import { Injectable } from "@angular/core";
import { environment } from "@env";
import { HttpClientInterceptor } from "@providers/httpClientInterceptor/httpClientInterceptor";
import * as cmsConstant from '../../constants/cms.constant';
import { ContactCenterContent, ContactCenterResponse, ContactFormContent, ContactFormData, ContactFormResponse, DisclaimerContent, DisclaimerResponse, HeaderContent, HeaderResponse } from "@interfaces/contactForm.interface";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Util } from "@util";
import { CmsUtils } from "@cms";
import { CONTACT_CENTER_RESPONSE, CONTACT_FORM_RESPONSE, DISCLAIMER_RESPONSE, HEADER_RESPONSE } from "./mocks/contactForm.mock";
import { HomeTransferContent, HomeTransferContentResponse } from "@interfaces/homeContent.interface";
import { HOME_TRANSFER_CONTENT_RESPONSE } from "./mocks/homeTransfer.mock";


@Injectable({
    providedIn: 'root'
})
export class CmsService {

    constructor(
        private http: HttpClientInterceptor,
        private cmsUtils: CmsUtils,
        private util: Util
    ) {}

    public loadFormContactContent(): Observable<ContactFormContent> {
        const url = `${environment.cmsApiUrl}items/${cmsConstant.FORM_TRANSFER_PATH}?fields=${cmsConstant.FORM_TRANSFER_FIELDS}`;

        return this.http.get(url, CONTACT_FORM_RESPONSE).pipe(
            map((response: ContactFormResponse) => this.cmsUtils.mapFormContact(response.data)),
            catchError(error => this.util.generalCatchError(error))
        );
    }

    public loadContactCenterContent(): Observable<ContactCenterContent> {
        const url = `${environment.cmsApiUrl}items/${cmsConstant.FORM_TRANSFER_PATH}?fields=${cmsConstant.CONTACT_CENTER_FIELDS}`;

        return this.http.get(url, CONTACT_CENTER_RESPONSE).pipe(
            map((response: ContactCenterResponse) => this.cmsUtils.mapContactCenter(response.data)),
            catchError(error => this.util.generalCatchError(error))
        );
    }

    public loadHeaderContent(): Observable<HeaderContent> {
        const url = `${environment.cmsApiUrl}items/${cmsConstant.FORM_TRANSFER_PATH}?fields=${cmsConstant.HEADER_FIELDS}`;

        return this.http.get(url, HEADER_RESPONSE).pipe(
            map((response: HeaderResponse) => this.cmsUtils.mapHeaderContent(response.data)),
            catchError(error => this.util.generalCatchError(error))
        );
    }

    public loadDisclaimerContent(): Observable<DisclaimerContent> {
        const url = `${environment.cmsApiUrl}items/${cmsConstant.FORM_TRANSFER_PATH}?fields=${cmsConstant.DISCLAIMER_FIELDS}`;

        return this.http.get(url, DISCLAIMER_RESPONSE).pipe(
            map((response: DisclaimerResponse) => this.cmsUtils.mapDisclaimerContent(response.data)),
            catchError(error => this.util.generalCatchError(error))
        );
    }

    public loadHomeContent(): Observable<HomeTransferContent> {
        const url = `${environment.cmsApiUrl}items/${cmsConstant.HOME_TRANSFER_PATH}?fields=${cmsConstant.HOME_TRANSFER_FIELDS}`;

        return this.http.get(url, HOME_TRANSFER_CONTENT_RESPONSE).pipe(
            map((response: HomeTransferContentResponse) => this.cmsUtils.mapHomeContent(response.data)),
            catchError(error => this.util.generalCatchError(error))
        );
    }
}
